import { useEffect } from "react";

export default function FeaturableWidget() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.featurable.com/widget/v2/embed.js";
    script.defer = true;
    script.charset = "UTF-8";

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      id="featurable-8d419c31-3df7-4c51-bc49-50f1779c283a"
      data-featurable-async
    />
  );
}